import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Container } from '../components/site/ui';

const ZIELE = [
  { to: '/fuer-unternehmen', label: 'Für Unternehmen' },
  { to: '/fuer-kandidaten', label: 'Für Kandidaten' },
  { to: '/berufe', label: 'IT-Berufe und Gehälter' },
  { to: '/kontakt', label: 'Kontakt' },
];

const NotFound: React.FC = () => (
  <section className="relative overflow-hidden py-24 md:py-32">
    <div className="bg-grid mask-radial pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" />
    <Container narrow className="relative text-center">
      <p className="font-mono text-7xl font-semibold text-primary/80 md:text-8xl">404</p>
      <h1 className="mt-6 text-3xl font-semibold text-white md:text-4xl">Diese Seite gibt es nicht</h1>
      <p className="mt-4 text-muted">Der Link ist vermutlich veraltet. Diese Seiten helfen weiter:</p>
      <ul className="mx-auto mt-10 grid max-w-lg gap-2 text-left">
        {ZIELE.map((z) => (
          <li key={z.to}>
            <Link to={z.to} className="card card-hover group flex items-center justify-between px-5 py-4">
              <span className="text-white">{z.label}</span>
              <ArrowRight className="size-4 text-subtle group-hover:text-primary" aria-hidden="true" />
            </Link>
          </li>
        ))}
      </ul>
    </Container>
  </section>
);

export default NotFound;
